import React, { useCallback } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import messages from '../../Claims.messages';
import styles from '../../Claims.module.scss';
import ClaimServicesPrimaryContactPopupMetaData from './ContactDetailsPopup.metadata.json5';


import { Link } from '@jutro/router';


function ContactLinkComponent(props) {
    const modalApi = useModal();
    const translator = useTranslator();
    const contactDetails = _.get(props, 'contactDetails');

    const getPrimaryMobilePhoneNumber = useCallback((item) => {
        if (item.cellNumber) {
            if (item.primaryPhoneType === 'mobile') {
                return `${item.cellNumber}(${translator(messages.modalPrimary)})`;
            }
            return item.cellNumber;
        }
        return null;
    }, [translator]);

    const getPrimaryWorkPhoneNumber = useCallback((item) => {
        if (item.workNumber) {
            if (item.primaryPhoneType === 'work') {
                return `${item.workNumber}(${translator(messages.modalPrimary)})`;
            }
            return item.workNumber;
        }
        return null;
    }, [translator]);

    const getPrimaryHomePhoneNumber = useCallback((item) => {
        if (item.homeNumber) {
            if (item.primaryPhoneType === 'home') {
                return `${item.homeNumber}(${translator(messages.modalPrimary)})`;
            }
            return item.homeNumber;
        }
        return null;
    }, [translator]);

    const getPrimaryContactPopupModalContent = useCallback((item) => {
        const isFieldVisible = item.contactType !== 'Company';
        const overrides = {
            primaryContactHomeNumber: {
                value: getPrimaryHomePhoneNumber(item),
                visible: isFieldVisible
            },
            primaryContactWorkNumber: {
                value: getPrimaryWorkPhoneNumber(item),
                visible: isFieldVisible
            },
            primaryContactMobileNumber: {
                value: getPrimaryMobilePhoneNumber(item),
                visible: isFieldVisible
            }
        };
        const readValue = (id, path) => {
            return readViewModelValue(
                ClaimServicesPrimaryContactPopupMetaData.pageContent,
                item,
                id,
                path,
                overrides
            );
        };

        const resolvers = {
            resolveValue: readValue,
            resolveClassNameMap: styles
        };
        return (
            <MetadataContent
                uiProps={ClaimServicesPrimaryContactPopupMetaData.pageContent}
                overrideProps={overrides}
                {...resolvers} />
        );
    }, []);

    const openContactPopup = useCallback(
        (event, item) => {
            event.preventDefault();
            const displayName = _.get(item, 'displayName', '');
            const renderServiceVendorContent = getPrimaryContactPopupModalContent(item);
            modalApi.showAlert({
                title: displayName,
                message: renderServiceVendorContent,
                status: 'info',
                icon: 'gw-error-outline'
            }).catch(_.noop);
        },
        [getPrimaryContactPopupModalContent]
    );

    return (
        <Link onClick={(event) => openContactPopup(event, contactDetails)} href="/">
            {contactDetails.displayName}
        </Link>
    );
}

export default ContactLinkComponent;
